import React, { useRef, useLayoutEffect } from 'react'

interface TruncateProps {
  children: React.ReactNode
  width?: number
  onTruncate?: (isTruncated: boolean) => void
  trimWhitespace?: boolean
}

const Truncate = ({ children, width, onTruncate, trimWhitespace }: TruncateProps): JSX.Element => {
  const ref = useRef<HTMLSpanElement>(null)
  const text = trimWhitespace === true && typeof children === 'string' ? children.trim() : children

  useLayoutEffect(() => {
    if (ref.current !== null && onTruncate !== undefined) {
      onTruncate(ref.current.scrollWidth > ref.current.clientWidth)
    }
  })

  return (
    <span
      ref={ref}
      style={{
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: width !== undefined ? `${width}px` : '100%'
      }}
    >
      {text}
    </span>
  )
}

export default Truncate
